import { PaginatorDynamicDatasource } from '@/shared/resources/datasources/paginator/paginator-dynamic-datasource'
import clinicalRequestService from '@/modules/clinicalModule/services/clinicalRequestService'
import { Nullable } from '@/shared/types/app.types'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

export class ClinicalDatasource<T> extends PaginatorDynamicDatasource<T> {
    private readonly _externalFilterModel: Nullable<CommonFilterModel>

    constructor(url: string, externalFilterModel?: CommonFilterModel) {
        super(clinicalRequestService, url)
        this._externalFilterModel = externalFilterModel
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        const _filterModel =
            this._externalFilterModel
                ? Object.assign(filterModel, this._externalFilterModel)
                : filterModel
        return this.service.paginator(_filterModel, params, this._url)
    }
}
